// extracted by mini-css-extract-plugin
export default {"page":"LandingPage_page__WcCcr"};